import { Component, ElementRef, ViewChild } from '@angular/core';
import { Proyecto } from 'src/app/shared/model/gestion-proyectos/proyecto';
import { EstatusProyecto } from 'src/app/shared/model/proceso/estadoProyecto';
import { OperativoService } from '../../../opeartivo.service';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, RouterModule } from '@angular/router';
import { PdfService } from '../../../Directivas/PdfService';
import { EvidenciaOportunidad } from 'src/app/shared/model/gestion-proyectos/evidenciasOportunidad';
import { ProyectosService } from 'src/app/proyectos/proyectos.service';
import { Msg } from 'src/app/utilerias/mensajes/Msg';
import { VoboOportunidadComponent } from './vobo-oportunidad/vobo-oportunidad.component';
import { SeguimientoOportunidadBaseComponent } from '../../seguimiento-oportunidad.component';
import { ArchivosUtileriasService } from 'src/app/utilerias/service/archivo-utilerias.service';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatListModule } from '@angular/material/list'; // FIX: para mat-selection-list / mat-list-option


@Component({
    selector: 'app-seguimiento-oportunidad',
    standalone: true,
    templateUrl: './seguimiento-oportunidad.component.html',
    imports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      RouterModule,
      MatFormFieldModule,
      MatInputModule,
      MatSelectModule,
      MatIconModule,
      MatButtonModule,
      MatTooltipModule,
      MatDialogModule,
      NgxMatSelectSearchModule,
      MatDatepickerModule,
      MatListModule, // FIX
    ],
    styleUrls: ['./../../seguimiento-oportunidad.component.css'],
    
})
export class SeguimientoOportunidadComponent extends SeguimientoOportunidadBaseComponent {
  infoProyecto: Proyecto = new Proyecto();
  listaEstimacionGuardada: EvidenciaOportunidad[] = [];
  listaArchivosGralGuardada: EvidenciaOportunidad[] = [];
  @ViewChild('downloadDocument') private download: ElementRef;
  titulo: string = "";
  tituloComentario: string = "";

  
  constructor(
    protected service: OperativoService,
    protected pdfService: PdfService,
    protected dialog: MatDialog,
    protected sanitizer: DomSanitizer, 
    protected msg: Msg,
    private readonly router: Router, 
    private readonly proyectosService: ProyectosService,
    protected archivoService: ArchivosUtileriasService
  ) {
      super(service, pdfService, msg, dialog, sanitizer,archivoService);
     }

  ngOnInit() {
    this.infoProyecto = JSON.parse(localStorage.getItem('datoProyecto'));
    this.titulo = "SeguimientoMarketing";
    this.tituloComentario = "Comentario Marketing";
    this.consultarComentarios(this.infoProyecto.idGit);
    this.infoProyecto.comentarios.forEach(element => {
      element.estatus = EstatusProyecto[element.estado.toString()];
    });
  
    
    this.infoProyecto.archivos.forEach(file => {
      let lowerCaseFileName = file.name.toLowerCase(); 
    
      if (this.regexFormatoEstimacion.test(lowerCaseFileName)) {
        this.listaEstimacionGuardada.push(file);
      } else {
        this.listaArchivosGralGuardada.push(file);
      }

    });
    console.log("listaEstimacionGuardada::"+this.listaEstimacionGuardada.length);
  }




  public regresarEvent() {
    if (this.infoProyecto.estado === "EST_MARKETING") {
      this.getConfirmacionRegresar().fire().then((resultado) => {
        if (resultado.isConfirmed) 
          this.router.navigate(['PROCESO/oportunidadmarketing']);
      });
     
    } else
      this.router.navigate(['PROCESO/oportunidadmarketing']);
    
  }
 

  public guardarOportunidadEvent() {
    if (this.listaEstimacionAgregar.length > 0) {
      this.service.guardarArchivoGit(this.obtenerRequestFileForm(this.infoProyecto.idGit,this.listaEstimacionAgregar))
      .subscribe(
        ((response :any)=> {
          if (response?.status && response.status === "ok") {
            if(this.infoProyecto.archivos)
              this.infoProyecto.archivos = this.infoProyecto.archivos.concat(this.obtenerListaEstimacionesAgregar(this.listaEstimacionAgregar));
            else
              this.infoProyecto.archivos= this.obtenerListaEstimacionesAgregar(this.listaEstimacionAgregar);
            
            this.guardarOportundadService();
           
          }
        })
      );    
    }
  }

  private guardarOportundadService() {
    this.infoProyecto.comentarios = this.listaComentarios;
    this.service.guardarOportunidadSeguimiento(this.infoProyecto).subscribe(respuesta => {
      if (respuesta.pCodRetorno == "00000") {
        this.msg.showSuccessNotification("top"," Oportunidad actualizada exitosamente.");
        this.router.navigate(['PROCESO/oportunidadmarketing']);
      }
      else 
        this.msg.showErrorNotification("top","Ocurrió un problema al actualizar la oportunidad.");
      
    });
  }

  public enviarOportunidadEvent() {
    let tituloComentario ="Enviar oportunidad a ODP";
    if (this.infoProyecto.estado== EstatusProyecto.getName(EstatusProyecto.REV_MARKETING))
      tituloComentario ="Registrar envio de propuesta a cliente";

    this.getComentarioCambioEstado().fire({ title:tituloComentario}).then((resultado) => {
      if (resultado.value) {
        if (this.listaEstimacionAgregar.length > 0) {
          this.service.guardarArchivoGit(this.obtenerRequestFileForm(this.infoProyecto.idGit,this.listaEstimacionAgregar))
          .subscribe(
            ((response :any)=> {
              if (response?.status && response.status === "ok") {
                if(this.infoProyecto.archivos)
                  this.infoProyecto.archivos = this.infoProyecto.archivos.concat(this.obtenerListaEstimacionesAgregar(this.listaEstimacionAgregar));
                else
                  this.infoProyecto.archivos= this.obtenerListaEstimacionesAgregar(this.listaEstimacionAgregar);
                
              this.enviarOportunidadService(resultado.value);
               
              }
            })
          );    
        }else
          this.enviarOportunidadService(resultado.value);

      }
    })
  }
 
  private enviarOportunidadService(comentario){
    this.infoProyecto.comentarios = this.listaComentarios;
    this.service.enviarOportunidad(this.infoProyecto).subscribe(respuesta => {
      if (respuesta.pCodRetorno === "00000") {
        if (this.infoProyecto.estado== EstatusProyecto.getName(EstatusProyecto.REV_MARKETING))
          this.msg.showSuccessNotification("top","La oportunidad se encontrará en espera de VoBo por parte del cliente");
        else
          this.msg.showSuccessNotification("top","Oportunidad enviada al departamento de ODP");
        this.guardarComentarioService(this.infoProyecto,comentario);
        this.router.navigate(['PROCESO/oportunidadmarketing']);
      } else {
        this.msg.showErrorNotification("top","Ocurrió un problema al enviar la oportunidad.");
      }
    })
  }

  public rechazarOportunidadEvent() {
    this.getComentarioRechazo().fire({ title: "La oportunidad regresará a 'Revisión ODP'"})
    .then((resultado) => {
      if (resultado.value)
        this.rechazarOportunidadService(resultado.value);

    });
  }

  private rechazarOportunidadService(comentario:string){
    this.infoProyecto.comentarios = this.listaComentarios;
    this.service.rechazarSolicutd(this.infoProyecto).subscribe(resultado => {
      if (resultado.pCodRetorno === "00000") {
        this.msg.showSuccessNotification("top"," La solicitud ha sido rechazada.");
        this.guardarComentarioService(this.infoProyecto,comentario );
        this.router.navigate(['PROCESO/oportunidadmarketing']);
      }
      else
        this.msg.showErrorNotification("top","Ocurrió un problema al rechazar la oportunidad.");
     
    });
  }


  public solicitarVoboOportunidadEvent() {
    this.dialog.open(VoboOportunidadComponent, {
      height: '630px',
      width: '920px',
      panelClass: 'custom-modalbox',
      data: {
        idGit: this.infoProyecto.idGit,
        grupo: this.infoProyecto.grupo,
        nombreCliente: this.infoProyecto.nombreCliente,
        tituloComentario: this.tituloComentario,
        estado: this.infoProyecto.estado
      }
    }).afterClosed().subscribe(resultado => {
      if (resultado && resultado.codError === "00000"){
        this.infoProyecto.tipoVobo= resultado.tipoVobo;
        if ( this.infoProyecto.archivos)
          this.infoProyecto.archivos = this.infoProyecto.archivos.concat(resultado.listaArchivos);
        else
          this.infoProyecto.archivos = resultado.listaArchivos;
        this.aprobarOportunidadService(resultado.comentario);
      }
     
    });
  }

  private aprobarOportunidadService(comentario: string) {
    this.infoProyecto.comentarios = this.listaComentarios;
    this.service.enviarOportunidad(this.infoProyecto).subscribe(respuesta => {
      if (respuesta.pCodRetorno === "00000") {
        this.msg.showSuccessNotification("top","La oportunidad ha sido aprobada.");
        this.guardarComentarioService(this.infoProyecto,comentario );
        this.router.navigate(['PROCESO/oportunidadmarketing']);
      } else {
        this.msg.showErrorNotification("top","Ocurrió un problema al aprobar la oportunidad.");
      }
    });
   
  }

  public cancelarOportunidadEvent(){
    this.getComentarioRechazo().fire({ confirmButtonText: "Guardar", title: "Cancelar oportunidad",
       text:"La oportunidad será CERRADA por cancelación y no se le podrá dar seguimiento.Si estás seguro de continuar, agrega un comentario para explicar el motivo"})
    .then((resultado) => {
      if (resultado.value)
        this.cancelarOportunidadService(resultado.value);

    });

  }

  private cancelarOportunidadService(comentario:string) {
    this.infoProyecto.comentarios = this.listaComentarios;
    this.proyectosService.cancelarOportunidad(this.infoProyecto).subscribe((res) => {
        if (res.pCodRetorno === "00000") {
          this.msg.showSuccessNotification("top"," La solicitud ha sido cancelada.");
          this.guardarComentarioService(this.infoProyecto,comentario );
          this.router.navigate(["PROCESO/oportunidadmarketing"]);
        } else {
          this.msg.showErrorNotification("top","Ocurrió un problema al cancelar la oportunidad.");
      }});
  }
     
      
}